import {CommonBuildConfigurationInput as BuildConfigurationInput} from '../commonConfiguration.types'

import {PlusLoadConfiguration} from './types'

export const buildPlusLoadConfiguration = ({
  options
}: BuildConfigurationInput): PlusLoadConfiguration => {
  return {
    plusLoadExpected: {
      enabled: options.constraints.quantityChangeExpected.isEnabled
    }
  }
}
